import { type FC, lazy, useState } from "react"
import styled from "styled-components"

import Button from "~/components/Button"
import Checkbox from "~/components/Checkbox"
import FeatureIntroduction from "~/components/FeatureIntroduction"
import { usePlatform } from "~/contexts/UserContext"
import routes from "~/utilities/routes"
import { lightTextColor } from "~/utilities/styles"

import Preview from "./Preview"

const CertificatesImage = lazy(() => import("./CertificatesImage"))

type Props = { courseTitle: string; value: boolean; onChange(value: boolean): void }
const IssueCertificates: FC<Props> = ({ courseTitle, value, onChange }) => {
	const platform = usePlatform()!

	const [isPreviewOpen, setPreviewOpen] = useState(false)

	return (
		<Container>
			<FeatureIntroduction
				illustration={CertificatesImage}
				title="Issue certificates"
				text="Turn this on to automatically give certificates to users when they finish a course. This way, they get official proof of their achievement that they can share with others."
			>
				{platform.plan.access.certificates ? (
					<>
						<Checkbox label="Enable" isChecked={value} onChange={onChange} />
						<Button variant="link" onClick={() => setPreviewOpen(true)}>
							Preview certificate
						</Button>
						<Preview
							courseTitle={courseTitle}
							isOpen={isPreviewOpen}
							onClose={() => setPreviewOpen(false)}
						/>
					</>
				) : (
					<>
						<Text>You need to upgrade your plan to access this feature.</Text>
						<Button variant="primary" onClick={routes.settings.billing.plans()}>
							Browse plans
						</Button>
					</>
				)}
			</FeatureIntroduction>
		</Container>
	)
}

const Container = styled.div`
	margin-top: 24px;
`

const Text = styled.p`
	color: ${lightTextColor};
	text-align: center;
	max-width: 500px;
	font-style: italic;
`

export default IssueCertificates
